<template>
<div class="chapter">
<div class="inner_page">
<section aria-label="Dedication" role="doc-dedication">
<p class="ded"><span aria-label="page vii" id="page_vii" role="doc-pagebreak">To Michelle, Chris, Audrey, Doug, Sean, and Mallory.</span></p>
<p class="ded1">Thanks for letting me in the club.</p>
</section>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// dedication.vue?3c10a4c0